interface SessionDetailCacheState {
  sessionId: number | null
  detail: Record<string, unknown> | null
}

// 세션 상세 페이지 진입 시 라우터 가드(권한 체크)가 이미 받아온 GET /api/sessions/:session_no
// 응답을 페이지 컴포넌트가 재사용하기 위한 단일 항목 캐시 (dataDetailCache.ts와 같은 방식).
// 세션 상세 응답은 세션의 데이터 목록까지 담으므로 같은 요청을 두 번 보내지 않는다.
export const useSessionDetailCacheStore = defineStore('sessionDetailCache', {
  // 네비게이션 1회에만 쓰이는 임시 캐시라 로컬 저장소에 영속화할 필요가 없음
  // (앱 전역에 auto persist 플러그인이 걸려 있어 명시적으로 꺼준다)
  persist: false,
  state: (): SessionDetailCacheState => ({
    sessionId: null,
    detail: null,
  }),
  actions: {
    set(sessionId: number, detail: Record<string, unknown>) {
      this.sessionId = sessionId
      this.detail = detail
    },
    // sessionId 가 일치할 때만 캐시를 꺼내주고, 꺼낸 뒤에는 즉시 비운다(1회성 소비).
    consume(sessionId: number): Record<string, unknown> | null {
      if (this.sessionId === sessionId && this.detail) {
        const detail = this.detail
        this.clear()
        return detail
      }
      return null
    },
    clear() {
      this.sessionId = null
      this.detail = null
    },
  },
})
